<template>
  <div class="firm-body">
    <!-- 标题  -->
    <p class="title-Individual-center">
      <span>招聘管理</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">{{ routeName }}</span>
    </p>
    <div class="box">
      <div class="left">
        <el-select placeholder="请选择职业类型" @change="optionsChange" v-model="positionCode">
          <el-option label="全部职位" value="">
          </el-option>
          <el-option v-for="item in options" :key="item.positionId" :label="item.positionName" :value="item.positionId">
          </el-option>
        </el-select>
        <div class="calendar-text">
          <span style="color: #409eff ;font-size: 18px;">{{ dateObj.dateText }}</span>
          <span>{{ dateObj.week }} 00：00-{{ hour }}：{{ minute }}</span>
        </div>
        <calendar class="firm-clickable" ref="calendarRef" @clickDay="clickDay" :scheduleList="scheduleList"></calendar>
        <div class="calendar-text2">
          <dateTime ref="dateTime" @getInput="getInput" @getInput2="getInput2"></dateTime>
        </div>
      </div>
      <div class="right">
        <div class="right-status">
          <div :class="index != isIndex ? 'status-item' : 'status-active'" v-for="item, index in statusList"
            :key="index" @click="statusChange(item, index)">{{ item.name }}（{{ item.num }}）</div>
        </div>
        <div class="interview-item" v-for="item, index in list" :key="index">
          <div class="flex-box2" style="width: 210px">
            <img :src="item.eliteAvatar" alt="" style="width: 40px;height: 40px;">
            <div class="" style="width: 155px; margin-left: 15px;">
              <div class="flex-box" style="margin-bottom: 12px;">
                <span style="font-size: 16px;">{{ item.eliteName }}</span>
                <span>{{ item.sexName }}</span>
                <span>{{ item.age }}岁</span>
                <span>{{ item.xlName }}</span>
              </div>
              <div class="flex-box">
                <span>{{ item.workExpYear }}年</span>
                <span>{{ item.positionName }}</span>
                <span>{{ item.hopeSalaryRange }}</span>
              </div>
            </div>
          </div>
          <div style="margin-left: 20px;">
            <div style="margin-bottom: 12px;">
              <span>面试时间：{{ item.interviewTime }}</span>
            </div>
            <el-tooltip class="item" effect="dark" :content="item.address" placement="top">
              <div style="width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                面试地点：{{ item.address }}
              </div>
            </el-tooltip>
          </div>
          <div style="width:30px">
            <img src="@/assets/imgs/zaixiangoutong@3x.svg" alt="" style="width: 100%;">
          </div>
          <div style="width:80px">
            <span style="font-size: 20px;color: #FE574A;" v-if="item.interviewStatus == 4">未面试</span>
            <span style="font-size: 20px;color: #FF9601;" v-if="item.interviewStatus == -1">待面试</span>
            <span style="font-size: 20px;color: #333;" v-if="item.interviewStatus == 3">已面试</span>
            <span style="font-size: 20px;color: #FE574A;" v-if="item.interviewStatus == 5">已拒绝</span>
            <span style="font-size: 20px;color: #409eff ;" v-if="item.interviewStatus == 0">待确认</span>
          </div>
          <div>
            <!-- <div>
              <el-button type="text" @click="visChange(item, 'state')">更改状态</el-button>
            </div> -->
            <!-- <div>
              <el-button type="text">反馈</el-button>
            </div> -->
            <div>
              <el-button type="text" @click="visChange(item, 'time')"
                v-if="item.interviewStatus == 0 || item.interviewStatus == -1">更改时间</el-button>
            </div>
          </div>
        </div>
        <div class="paging-box">
          <div class="paging">
            <paging :pagingObj="pagingObj" @handleCurrentChange="handleCurrentChange"></paging>
          </div>
        </div>
      </div>

    </div>
    <dialogModel
      title="更改时间"
      :visible.sync="dialogVisible"
      @handleClose="dialogVisible = false"
      @handleOk="submitForm"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="地址选择" prop="addressId">
          <el-select v-model="ruleForm.addressId" placeholder="请选择面试地址" style="width: 400px;">
            <el-option :label="item.cityName + item.regionName + item.companyFullAddress" :value="item.id"
              v-for="item, index in companyAddressList" :key="index">{{ item.cityName }}{{ item.regionName }}{{
                item.companyFullAddress }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间选择" prop="interviewTime">
          <!--  :picker-options="pickerOptions" -->
          <el-date-picker v-model="ruleForm.interviewTime" type="datetime" placeholder="选择日期时间" style="width: 400px;"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </dialogModel>
    <!-- 底部分页 -->

  </div>
</template>
<script>
import moment from "moment";
import calendar from "../components/calendar.vue"
import dateTime from "../components/dateTime.vue"
import * as API from '@/assets/api/firm/firmRecruit.js';
// 引入分页组件
import paging from "../../../../components/paging.vue";
export default {
  components: {
    calendar, paging, dateTime
  },
  data() {
    return {
      //分页数据
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 8, // 一页显示多少个
        totalDevice: 10, //总数
      },
      routeName: '',
      // 列表
      list: [],
      // 状态
      interviewStatus: '',
      // 开始时间
      startTime: '',
      // 结束时间
      endTime: '',
      // 职业编码/id
      positionCode: '',
      // 职业列表
      options: [],
      // 时间对象
      dateObj: {},
      minute: '00',
      hour: '18',
      // 状态列表
      statusList: [{
        name: '全部',
        id: '',
        num: 0,

      }, {
        name: '待确认',
        id: 0,
        num: 0,
      }, {
        name: '待面试',
        id: -1,
        num: 0,
      }, {
        name: '已面试',
        id: 3,
        num: 0,
      }, {
        name: '未面试',
        id: 4,
        num: 0,
      }, {
        name: '已拒绝',
        id: 5,
        num: 0,
      }],
      isIndex: 0,
      // 控制弹框
      dialogVisible: false,
      // 判断是否打开哪个弹框
      isTimeState: '',
      // 地址列表
      companyAddressList: [],
      // 限制今天之前
      // pickerOptions: {
      //   disabledDate(time) {
      //     return time.getTime() < Date.now() - 8.64e7;
      //   }
      // },
      // 本月有面试的时间列表
      scheduleList: [],
      // 表单数据
      ruleForm: {
        addressId: '',
        interviewTime: '',
        id: ''
      },
      // 校验规则
      rules: {
        addressId: [
          { required: true, message: '请选择地址', trigger: 'change' },
        ],
        interviewTime: [
          { required: true, message: '请选择面试时间', trigger: 'change' },
        ],
      }
    };
  },
  created() {
    this.routeName = this.$route.name;
  },
  mounted() {
    this.dateObj = this.$refs.calendarRef.dateObj
    this.startTime = this.dateObj.date.replaceAll("/", "-") + ' 00:00:00'
    this.endTime = this.dateObj.date.replaceAll("/", "-") + ' 18:00:59'
    this.getMethods()
    this.positionSearchList()
  },
  methods: {
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val
      this.adminInterviewManage()
    },
    getMethods() {
      this.adminInterviewManage()
      this.interviewManageCount()
      this.adminInterviewSchedule()
    },
    // 获取时
    getInput(val) {
      this.hour = val
      this.getMethods()
    },
    // 获取分
    getInput2(val) {
      this.minute = val
      this.getMethods()
    },
    // 面试日程列表
    adminInterviewSchedule() {
      let data = {
        data: {
          companyId: this.$store.getters.getCompany.id,
          adminId: this.$store.getters.getUser.id,
          startTime: moment().startOf('months').format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment().endOf('months').format('YYYY-MM-DD HH:mm:ss')
        }
      }
      API.adminInterviewSchedule(data).then(res => {
        if (res.code == 0) {
          this.scheduleList = res.data.map(item => {
            return item.scheduleTime
          })
        }
      })
    },
    // 面试管理-面试状态统计
    interviewManageCount() {
      let data = {
        data: {
          companyId: this.$store.getters.getCompany.id,
          adminId: this.$store.getters.getUser.id,
          positionId: this.positionCode,
          interviewStatus: this.interviewStatus,
          startTime: this.startTime,
          endTime: this.endTime
        }
      }
      API.interviewManageCount(data).then(res => {
        if (res.code == 0) {
          this.statusList[0].num = res.data.total
          this.statusList[1].num = res.data.waitConfirmCount?res.data.waitConfirmCount:0
          this.statusList[2].num = res.data.waitInterviewCount?res.data.waitInterviewCount:0
          this.statusList[3].num = res.data.interviewedCount?res.data.interviewedCount:0
          this.statusList[4].num = res.data.notInterviewCount?res.data.notInterviewCount:0
          this.statusList[5].num = res.data.refuseCount?res.data.refuseCount:0
        }
      })
    },
    // 面试管理列表
    adminInterviewManage() {
      let data = {
        pageNo: this.pagingObj.currentPage,
        pageSize: this.pagingObj.pageSize,
        data: {
          companyId: this.$store.getters.getCompany.id,
          adminId: this.$store.getters.getUser.id,
          positionId: this.positionCode,
          interviewStatus: this.interviewStatus,
          startTime: this.startTime,
          endTime: this.endTime
        }
      }
      API.adminInterviewManage(data).then(res => {
        if (res.code == 0) {
          this.list = res.data.list
          this.pagingObj.totalDevice = res.data.total
        }
      })
    },
    // 点击日历
    clickDay(dateObj) {
      this.dateObj = {
        date: dateObj.date,
        week: dateObj.week,
        dateText: dateObj.dateText
      }
      this.startTime = this.dateObj.date.replaceAll("/", "-") + ' 00:00:00'
      this.endTime = this.dateObj.date.replaceAll("/", "-") + ' ' + this.hour + ':' + this.minute + ':59'
      this.getMethods()
    },
    // 职业类型筛选
    optionsChange(item) {
      this.positionCode = item
      this.getMethods()
    },
    // 获取企业已发布的二类职位编码列表
    positionSearchList() {
      let data = {
        data: {
          companyId: this.$store.getters.getCompany.id,
          publishUserId: this.$store.getters.getUser.id
        }
      }
      API.positionSearchList(data).then(res => {
        this.options = res.data
      })
    },
    // 面试状态切换
    statusChange(item, index) {
      this.isIndex = index
      this.interviewStatus = item.id
      this.getMethods()
    },
    // 更改时间/状态
    visChange(item, name) {
      this.isTimeState = name
      this.getCompanyAddress()
      this.dialogVisible = true
      this.ruleForm.interviewTime = item.interviewTime
      this.ruleForm.addressId = item.companyAddressId
      this.ruleForm.id = item.id
    },
    // 获取公司地址
    getCompanyAddress() {
      let data = {
        data: {
          companyId: this.$store.getters.getCompany.id,
        },
        pageNo: 1,
        pageSize: 1000,
      };
      API.getCompanyAddress(data).then(res => {
        this.companyAddressList = res.data.list
      })
    },
    // 更改时间地址确认
    submitForm() {
      let that = this
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = {
            data: that.ruleForm
          }
          API.changeInterviewTime(data).then(res => {
            if (res.code == 0) {
              that.$tool.PromptBox("success", '操作成功！');
              that.dialogVisible = false
              this.getMethods()
            }
          })
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.demo-ruleForm {
  margin: 5% 15%;
}

.firm-body {
  .box {
    width: 1200px;
    min-height: 700px;
    box-sizing: border-box;
    overflow-y: auto;
    margin-top: 20px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
    border-radius: 20px;
    padding: 10px 30px;
    display: flex;
    justify-content: space-between;

    .left {
      width: 300px;

      .calendar-text {
        height: 50px;
        line-height: 50px;
        background: #FFFFFF;
        box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
        border-radius: 10px;
        font-size: 14px;
        padding: 0 10px;
        margin: 20px 0;
        display: flex;
        justify-content: space-between;
      }

      .calendar-text2 {
        height: 60px;
        background: #FFFFFF;
        box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
        border-radius: 10px;
        font-size: 24px;
        margin: 20px 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .right {
      width: 790px;

      .right-status {
        display: flex;
        padding-bottom: 20px;
        margin-top: 20px;

        .status-item {
          width: 110px;
          height: 35px;
          background: #eee;
          border-radius: 5px;
          font-size: 12px;
          line-height: 35px;
          text-align: center;
          color: #333;
          margin-right: 20px;
          cursor: pointer;
        }

        .status-active {
          width: 110px;
          height: 35px;
          background: rgba(97, 144, 232, 0.20);
          border-radius: 5px;
          font-size: 12px;
          line-height: 35px;
          text-align: center;
          color: #409eff ;
          margin-right: 20px;
          cursor: pointer;
        }
      }

      .interview-item {
        height: 80px;
        background: #FFFFFF;
        box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
        border-radius: 10px;
        margin: 20px 0;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: #333;
      }
    }
  }
}

// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;

  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>